var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 26,
    r: 17,
    stroke: "#2B5297",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10313 28.16V24.6H16.6631V17.52H20.3431V24.6H27.9031V28.16H20.3431V35.28H16.6631V28.16H9.10313Z",
    fill: "#2B5297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddClasses);
export default __webpack_public_path__ + "static/media/add_classes.81f908a1074f241c4029f7ab9498a659.svg";
export { ForwardRef as ReactComponent };